import { Ambiente } from "../app/components/shared/enum/ambiente.enum";

export const environment = {
  ambiente: Ambiente.DEV,
  newRelicEnabled: false,
  urlWeb: 'https://dev-app.claribot.com.br/',
  urlBase: 'https://dev-api.claribot.com.br/api',
  urlOzirizHealth: 'https://hml-api.oziriz.com.br/actuator/health',
  urlRepositorioClaribot: 'https://repositorio.gruposfa.com.br/api-claribot/hml',
  urlSocket: 'https://dev-api.claribot.com.br/wss-socket',
  urlScheduleHealth: 'https://scheduler.claribot.com.br/actuator/health',
};
